// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/node_modules/.pnpm/@umijs+runtime@3.5.43_react@16.14.0/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "exact": true,
    "path": "/ui-example",
    "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/ui-example').default
  },
  {
    "exact": true,
    "path": "/nodePausePreview",
    "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/nodePausePreview').default
  },
  {
    "path": "/",
    "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/layouts/FLayout').default,
    "routes": [
      {
        "exact": true,
        "path": "/",
        "redirect": "/dashboard"
      },
      {
        "exact": true,
        "path": "/invitation",
        "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/invitation/index').default,
        "title": "内测资格申请 - Freelog"
      },
      {
        "exact": true,
        "path": "/dashboard",
        "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/dashboard/index').default,
        "title": "概览 - Freelog"
      },
      {
        "exact": true,
        "path": "/market",
        "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/discover/index').default,
        "title": "市场资源 - Freelog"
      },
      {
        "exact": true,
        "path": "/examples",
        "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/discover/index').default,
        "title": "示例节点 - Freelog"
      },
      {
        "exact": true,
        "path": "/search",
        "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/search/index').default,
        "title": "站内搜索 - Freelog"
      },
      {
        "exact": true,
        "path": "/storage",
        "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/storage').default,
        "title": "存储空间 - Freelog"
      },
      {
        "path": "/node",
        "routes": [
          {
            "exact": true,
            "path": "/node/creator",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/node/creator').default,
            "title": "节点创建 - Freelog"
          },
          {
            "path": "/node/formal/:id",
            "exact": true,
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/node/formal/$id').default,
            "title": "节点管理 - Freelog"
          },
          {
            "path": "/node/informal/:id",
            "exact": true,
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/node/informal/$id').default,
            "title": "测试节点管理 - Freelog"
          },
          {
            "path": "/node/exhibit",
            "routes": [
              {
                "path": "/node/exhibit/formal/:id",
                "exact": true,
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/node/exhibit/formal/$id').default,
                "title": "展品管理 - Freelog"
              },
              {
                "path": "/node/exhibit/informal/:id",
                "exact": true,
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/node/exhibit/informal/$id').default,
                "title": "测试展品管理 - Freelog"
              },
              {
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/404').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/node/collectionExhibit",
            "routes": [
              {
                "path": "/node/collectionExhibit/formal/:id",
                "exact": true,
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/node/collectionExhibit/formal/$id').default,
                "title": "展品管理 - Freelog"
              },
              {
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/404').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/node/createdCollectionExhibit",
            "routes": [
              {
                "path": "/node/createdCollectionExhibit/formal/:id",
                "exact": true,
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/node/createdCollectionExhibit/formal/$id').default,
                "title": "展品管理 - Freelog"
              },
              {
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/404').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/node/collectionExhibitCreator/:nodeID",
            "exact": true,
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/node/collectionExhibitCreator/$nodeID').default,
            "title": "创建展品合集 - Freelog"
          },
          {
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/404').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/resource",
        "routes": [
          {
            "exact": true,
            "path": "/resource",
            "redirect": "/resource/list"
          },
          {
            "exact": true,
            "path": "/resource/list",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/list').default,
            "title": "我的资源 - Freelog"
          },
          {
            "exact": true,
            "path": "/resource/collect",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/list').default,
            "title": "我的收藏 - Freelog"
          },
          {
            "exact": true,
            "path": "/resource/collection",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/list').default,
            "title": "我的合集 - Freelog"
          },
          {
            "exact": true,
            "path": "/resource/creator",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/creator').default,
            "title": "创建资源 - Freelog"
          },
          {
            "exact": true,
            "path": "/resource/collectionCreator",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/collectionCreator').default,
            "title": "创建资源 - Freelog"
          },
          {
            "exact": true,
            "path": "/resource/creatorBatch",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/creatorBatch').default,
            "title": "批量创建资源 - Freelog"
          },
          {
            "exact": true,
            "path": "/resource/creatorEntry",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/creatorEntry').default,
            "title": "发行入口 - Freelog"
          },
          {
            "exact": true,
            "path": "/resource/details/:id",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/details/$id').default,
            "title": "市场资源 - Freelog"
          },
          {
            "exact": true,
            "path": "/resource/collectionDetails/:id",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/collectionDetails/$id').default,
            "title": "市场资源 - Freelog"
          },
          {
            "path": "/resource/sidebar",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/sidebar').default,
            "routes": [
              {
                "exact": true,
                "path": "/resource/sidebar/info/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/sidebar/info/$id').default,
                "title": "资源信息 - Freelog"
              },
              {
                "exact": true,
                "path": "/resource/sidebar/policy/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/sidebar/policy/$id').default,
                "title": "授权策略 - Freelog"
              },
              {
                "exact": true,
                "path": "/resource/sidebar/contract/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/sidebar/contract/$id').default,
                "title": "授权合约 - Freelog"
              },
              {
                "exact": true,
                "path": "/resource/sidebar/dependency/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/sidebar/dependency/$id').default,
                "title": "依赖及其授权 - Freelog"
              },
              {
                "exact": true,
                "path": "/resource/sidebar/versionInfo/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/sidebar/versionInfo/$id').default,
                "title": "资源版本 - Freelog"
              }
            ]
          },
          {
            "path": "/resource/collectionSidebar",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/collectionSidebar').default,
            "routes": [
              {
                "exact": true,
                "path": "/resource/collectionSidebar/info/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/collectionSidebar/info/$id').default,
                "title": "合集信息 - Freelog"
              },
              {
                "exact": true,
                "path": "/resource/collectionSidebar/policy/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/collectionSidebar/policy/$id').default,
                "title": "授权策略 - Freelog"
              },
              {
                "exact": true,
                "path": "/resource/collectionSidebar/contract/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/collectionSidebar/contract/$id').default,
                "title": "授权合约 - Freelog"
              },
              {
                "exact": true,
                "path": "/resource/collectionSidebar/dependency/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/collectionSidebar/dependency/$id').default,
                "title": "依赖及其授权 - Freelog"
              },
              {
                "exact": true,
                "path": "/resource/collectionSidebar/versionInfo/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/collectionSidebar/versionInfo/$id').default,
                "title": "单品管理 - Freelog"
              }
            ]
          },
          {
            "exact": true,
            "path": "/resource/versionCreator/:id",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/resource/versionCreator/$id').default,
            "title": "版本创建 - Freelog"
          },
          {
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/404').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/result",
        "routes": [
          {
            "path": "/result/node",
            "routes": [
              {
                "path": "/result/node/create",
                "routes": [
                  {
                    "exact": true,
                    "path": "/result/node/create/success/:id",
                    "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/result/node/create/success/$id').default,
                    "title": "节点创建成功 - Freelog"
                  }
                ]
              },
              {
                "exact": true,
                "path": "/result/node/freeze/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/result/node/freeze/$id').default,
                "title": "节点冻结 - Freelog"
              }
            ]
          },
          {
            "path": "/result/collection",
            "routes": [
              {
                "path": "/result/collection/create",
                "routes": [
                  {
                    "exact": true,
                    "path": "/result/collection/create/success/:id",
                    "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/result/collection/create/success/$id').default,
                    "title": "资源创建成功 - Freelog"
                  }
                ]
              }
            ]
          },
          {
            "path": "/result/resource",
            "routes": [
              {
                "path": "/result/resource/create",
                "routes": [
                  {
                    "exact": true,
                    "path": "/result/resource/create/success/:id",
                    "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/result/resource/create/success/$id').default,
                    "title": "资源创建成功 - Freelog"
                  }
                ]
              },
              {
                "path": "/result/resource/version",
                "routes": [
                  {
                    "path": "/result/resource/version/create",
                    "routes": [
                      {
                        "exact": true,
                        "path": "/result/resource/version/create/success/:id/:version",
                        "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/result/resource/version/create/success/$id/$version').default,
                        "title": "版本创建成功 - Freelog"
                      },
                      {
                        "exact": true,
                        "path": "/result/resource/version/create/release/:id/:version",
                        "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/result/resource/version/create/release/$id/$version').default,
                        "title": "版本正在创建 - Freelog"
                      }
                    ]
                  }
                ]
              },
              {
                "exact": true,
                "path": "/result/resource/freeze/:id",
                "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/result/resource/freeze/$id').default,
                "title": "资源冻结 - Freelog"
              }
            ]
          }
        ]
      },
      {
        "path": "/exception",
        "routes": [
          {
            "exact": true,
            "path": "/exception/403",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/403').default,
            "title": "暂无权限 - Freelog"
          },
          {
            "exact": true,
            "path": "/exception/404",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/404').default,
            "title": "未找到页面 - Freelog"
          },
          {
            "exact": true,
            "path": "/exception/unableToAccess",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/unableToAccess').default,
            "title": "无法访问 - Freelog"
          },
          {
            "exact": true,
            "path": "/exception/common",
            "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/common').default,
            "title": "无法访问 - Freelog"
          }
        ]
      },
      {
        "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/404').default,
        "exact": true
      }
    ]
  },
  {
    "component": require('C:/code/freelogfe/freelogfe-web-repos/packages/console/src/pages/exception/404').default,
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
